<template>
    <div class="sidebar">
        <el-menu
            class="sidebar-el-menu"
            :default-active="onRoutes"
            :collapse="collapse"
            background-color="rgba(51, 51, 51, 1)"
            text-color="#bfcbd9"
            active-text-color="#20a0ff"
            unique-opened
            router>
                <div class="u_suidao_name">{{suidaoName}}</div>
                <el-menu-item index="bridgeSurvey">
                    <i class="el-icon-menu"></i>
                    <span slot="title">桥隧概况</span>
                </el-menu-item>
                <el-menu-item index="bridgeDetails">
                    <i class="el-icon-s-order"></i>
                    <span slot="title">桥隧详情</span>
                </el-menu-item>
                <el-submenu index="">
                    <template slot="title">
                        <i class="el-icon-s-marketing"></i>
                        <span>运维管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="bridgeAbnormal">设备异常</el-menu-item>
                        <el-menu-item index="bridgeSoilstructure">土建结构异常</el-menu-item>
                        <el-menu-item index="bridgeRecord">故障排除记录</el-menu-item>
                        <el-menu-item index="bridgeUser">运维人员管理</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
        </el-menu>
    </div>
</template>

<script>
import bus from '../common/bus';
export default {
    data() {
        return {
            collapse: false,
            items: [
                {
                    icon: 'el-icon-menu',
                    index: 'bridgeSurvey',
                    title: '桥隧概况'
                },
                {
                    icon: 'el-icon-s-order',
                    index: 'bridgeDetails',
                    title: '桥隧详情'
                },
                {
                    icon: 'el-icon-s-marketing',
                    index: 'bridgeAbnormal',
                    title: '设备异常'
                },
                {
                    icon: 'el-icon-s-marketing',
                    index: 'bridgeSoilstructure',
                    title: '土建结构异常'
                },
                {
                    icon: 'el-icon-s-marketing',
                    index: 'bridgeRecord',
                    title: '故障排除记录'
                },
                {
                    icon: 'el-icon-s-marketing',
                    index: 'bridgeUser',
                    title: '运维人员管理'
                }
            ],
            suidaoName: ''
        };
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    created() {
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', msg => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });
        this.suidaoName = localStorage.getItem('suidaoName')
    }
};
</script>
